import React from "react";

//Other packages
import ReactFlow, { Background, useNodesState, useEdgesState, MiniMap, Controls } from "reactflow";
//All CSS
import { makeStyles } from "tss-react/mui";
//All wraper element
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

import { Node } from "./Node";
import "../../../MyWorkspace/scheduledJobs/DataPipeline/overview.css";

const useStyles = makeStyles()((theme) => ({
  container: {
    "& ::-webkit-scrollbar": {
      display: "none",
    },
  },
  GraphContainer: {
    height: "100%",
    margin: "25px",
  },
  canvasStyle: {
    width: "100%",
    height: "100%",
    borderRadius: "10px",
    background: "white",
    overflow: "auto",
    display: "flex",
  },
}));

const proOptions = { hideAttribution: true };

const getNodes = (objects) => {
  const nodes = [];
  const addedNodes = new Set();

  let ds = 0;
  let en = -1;

  objects.forEach((obj) => {
    if (obj.DataSource_id && !addedNodes.has(obj.DataSource_id)) {
      nodes.push({
        id: obj.DataSource_id,
        data: {
          label: obj.Source,
          hasConnector: !!obj.Entity_id,
        },
        type: "source",
        position: {
          x: 0,
          y: ds++ * 45,
        },
      });
    }

    if (obj.Entity_id && !addedNodes.has(obj.Entity_id)) {
      nodes.push({
        id: obj.Entity_id,
        data: {
          label: obj.Target,
          hasConnector: !!obj.DataSource_id,
        },
        type: "target",
        position: {
          x: 500,
          y: en++ * 45,
        },
      });
    }
  });

  return nodes;
};

const getEdges = (objects) => {
  const edges = [];

  objects.forEach((obj) => {
    if (obj.DataSource_id && obj.Entity_id)
      edges.push({
        id: `${obj.DataSource_id}-${obj.Entity_id}`,
        source: obj.DataSource_id.toString(),
        sourceHandle: null,
        target: obj.Entity_id.toString(),
        targetHandle: null,
        markerEnd: {
          type: "arrowclosed",
          width: 30,
          height: 30,
        },
      });
  });

  return edges;
};

const nodeTypes = {
  source: Node,
  target: Node,
};

const Mapping = ({ mappedObjects }) => {
  const { classes } = useStyles();

  const [nodes, , onNodesChange] = useNodesState(getNodes(mappedObjects));
  const [edges, , onEdgesChange] = useEdgesState(getEdges(mappedObjects));

  const onConnectStart = (event) => {
    // Prevent connection initiation
    event.preventDefault();
  };

  return (
    <Paper className={`${classes.GraphContainer} ${classes.container}`}>
      <Box className={classes.canvasStyle} id="canvas">
        <div className="reactflow-wrapper dndflow">
          <ReactFlow
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            nodeTypes={nodeTypes}
            proOptions={proOptions}
            fitView
            deleteKeyCode={"None"}
            onConnectStart={onConnectStart}
          >
            <MiniMap />
            <Controls />
            <Background />
          </ReactFlow>
        </div>
      </Box>
    </Paper>
  );
};

export default React.memo(Mapping);
